import {Component, OnInit} from '@angular/core';
import {PlaylistTrack, Track} from '../model/track';
import {MessageService} from '../service/message.service';
import {PlaylistService} from '../service/playlist.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TrackService} from '../service/track.service';

@Component({
  selector: 'app-playlist',
  templateUrl: './playlist.component.html',
  styleUrls: ['./playlist.component.css']
})
export class PlaylistComponent implements OnInit {
  tracks: Track[];
  playlistTracks: PlaylistTrack[];
  title: string;
  isPublic: boolean = false;
  selectedTrack: Track;
  playlistId: string;
  currentTrack: string;
  onPlaceOf: string;
  allTracks: Track[] = [];

  constructor(private messageService: MessageService,
              private playlistService: PlaylistService,
              private trackService: TrackService,
              private router: Router,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    let paramMap = this.route.snapshot.paramMap;
    if (paramMap.has("id")) {
      this.playlistId = paramMap.get("id");
      this.playlistService.get(this.playlistId)
        .flatMap(v => {
          this.title = v.name;
          this.isPublic = v.is_public;
          this.playlistId = v.id;
          return this.trackService.list();
        })
        .flatMap(v => {
          this.allTracks = v;
          return this.playlistService.tracks(this.playlistId);
        })
        .subscribe(v => {
          this.playlistTracks = v;
          this.playlistTracks.sort(function (t1, t2) {
            return t1.position - t2.position
          });
          this.tracks = this.allTracks.filter(t => !this.playlistTracks.some(pt => pt.id == t.id));
        }, err => this.messageService.addDefaultError(err));
    } else {
      this.playlistTracks = [];
      this.trackService.list().subscribe(v => {this.allTracks = Array.from(v); this.tracks = v;}, err => this.messageService.addDefaultError(err));
    }
  }

  onSubmitPlaylist() {
    if (this.playlistId) {
      this.playlistService.update(this.playlistId, this.title, this.isPublic)
        .subscribe(v => {
        }, err => this.messageService.addDefaultError(err));
    } else {
      this.playlistService.create(this.title, this.isPublic)
        .subscribe(v => this.playlistId = v.id, err => this.messageService.addDefaultError(err));
    }
  }

  onChooseTrack(event: any, playlistTrack: PlaylistTrack) {
    if (playlistTrack) {
      this.currentTrack = playlistTrack.id;
    }
  }

  onMoveTrack(event: any, playlistTrack: PlaylistTrack) {
    if (playlistTrack) {
      this.onPlaceOf = playlistTrack.id;
    }
  }

  onUpdateTrack(event: any) {
    if (this.currentTrack && this.onPlaceOf && this.currentTrack != this.onPlaceOf) {
      let from: number = this.playlistTracks.findIndex(value => value.id == this.currentTrack);
      let to: number = this.playlistTracks.findIndex(value => value.id == this.onPlaceOf);
      this.playlistService.moveTrack(this.playlistId, this.currentTrack, this.onPlaceOf)
        .subscribe(v => {
            this.currentTrack = undefined;
            this.onPlaceOf = undefined;
            let moved: PlaylistTrack[] = this.playlistTracks.splice(from, 1);
            this.playlistTracks.splice(to, 0, moved[0]);
            this.playlistTracks.forEach((q, i) => q.position = i + 1);
          }, err =>
            this.messageService.addDefaultError(err)
        );
    }
  }

  onRemoveTrack(playlistTrack: PlaylistTrack) {
    this.playlistService.removeTrack(this.playlistId, playlistTrack.id)
      .subscribe(v => {
        let idx: number = this.playlistTracks.indexOf(playlistTrack);
        this.playlistTracks.splice(idx, 1);
        this.tracks.push(new Track(
          playlistTrack.id,
          playlistTrack.name,
          playlistTrack.url,
          playlistTrack.image,
          playlistTrack.duration_ms,
          null,
          null,
          null,
          null
        ))
      }, err => this.messageService.addDefaultError(err));
  }

  onAddTrack() {
    if (this.selectedTrack) {
      this.playlistService.addTrack(this.playlistId, this.selectedTrack.id)
        .subscribe(v => {
          let playlistTrack: PlaylistTrack = new PlaylistTrack(
            this.selectedTrack.id,
            this.selectedTrack.name,
            this.selectedTrack.url,
            this.selectedTrack.image,
            this.selectedTrack.duration_ms,
            v.position
          );
          this.playlistTracks.splice(v.position - 1, 0, playlistTrack);
          let idx: number = this.tracks.indexOf(this.selectedTrack);
          this.tracks.splice(idx, 1);
          this.selectedTrack = null;
        }, err => this.messageService.addDefaultError(err));
    }
  }

  getTrackByPlayListTrack(plTrack: PlaylistTrack): Track {
    let foundTrack = this.allTracks.find(track => track.id == plTrack.id);
    return foundTrack;
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/playlist/playlist.component.ts